import { render, staticRenderFns } from "./orderCreatePos.vue?vue&type=template&id=a3a4ad26&scoped=true&"
import script from "./orderCreatePos.vue?vue&type=script&lang=js&"
export * from "./orderCreatePos.vue?vue&type=script&lang=js&"
import style0 from "./orderCreatePos.vue?vue&type=style&index=0&id=a3a4ad26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a4ad26",
  null
  
)

export default component.exports